import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import { Col, Form, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getannouncementdata, updateannouncement } from '../../actions/users';
import { toast } from 'react-toastify';
import { isEmpty } from '../../actions/commonFunction';


const initialFormValue = {
    'description': "",
    'url': "",
  
  }

const AnnouncementEdit = () => {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { announcementId } = useParams();


    const [formData, setFormData] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});

    const { description, url } = formData;

    useEffect(() => {
        getAnnouncementData()
    }, []);


    const onChange = (e) => {
        setFormData({
            ...formData,
            ...{
                [e?.target?.id]: e?.target?.value
            }
        })
    }


    const handleValidation = async (e) => {

        try {
            let errors = {};
            if (description == '') {
                errors.description = 'Description field is required'
            }
            if (url == '') {
                errors.url = "Url field is required";
            }
            setValidateError(errors)
            return errors
        } catch (err) {
            console.error("handleValidation_err", err)
        }
    }

    const handleFormSubmit = async (e) => {
        try {
            e.preventDefault();
            const validation = await handleValidation();
            let Objlen = await Object.keys(validation).length;
            

            if (Objlen == 0) {
                let reqData = { description, url, announcementId };
                let { loading, result, error } = await updateannouncement(reqData);
                if (isEmpty(error)) {
                    toast.success('Announcement updated successfully', 1000);
                    navigate('/announcementlist')
                } else {
                    setValidateError(error);
                }
            }

        } catch (err) {
            console.error("handleFormSubmit_err", err)
        }



    }


    const getAnnouncementData = async () => {

        try {
            
            let resp = await getannouncementdata(announcementId);
            
            if (resp.status == true) {
                setFormData({
                    ...formData,
                    ...{
                        description: resp.data.Description,
                        url: resp.data.Url
                    }
                })
            }
        } catch (err) {
            console.error("getAnnouncementData_err", err)
        }
    }

    return (
        <Layout>
            <div className="announcementedit">
                <Link to="/announcementlist" className="btn sitebtn mb-4">Back</Link>
                <h1 className="pagehead">Edit Announcement</h1>
                <div className="cardbox">
                    <Form>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control type="textarea" onChange={onChange} id="description" value={description||''} placeholder='Description' />
                                    {
                                        validateError.description && <span className="text-danger">{validateError.description}</span>
                                    }
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>URL</Form.Label>
                                    <Form.Control type="text" onChange={onChange} id="url" value={url||''} placeholder='URL' />
                                </Form.Group>
                                {
                                    validateError.url && <span className="text-danger">{validateError.url}</span>
                                }
                            </Col>
                        </Row>
                    </Form>
                    <button type="button" className="btn sitebtn py-2 px-3" onClick={handleFormSubmit}>Update</button>
                </div>
            </div>
        </Layout>
    )
}

export default AnnouncementEdit;